document.addEventListener('submit', function (e) {
  var form = e.target;
  if (!form || form.id !== 'DisciplineSeriesForm') return;

  // We will TRY fetch first, but if Shopify challenges, we fall back to normal submit.
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var btn = form.querySelector('button[type="submit"], input[type="submit"]');
  var err = document.getElementById('DisciplineError');
  var confirmUrl = '/pages/discipline-series-confirmed';

  function setBtn(text, disabled) {
    if (!btn) return;
    btn.disabled = !!disabled;
    if (btn.tagName === 'BUTTON') btn.textContent = text;
    if (btn.tagName === 'INPUT') btn.value = text;
  }

  if (err) err.style.display = 'none';
  setBtn('Submitting...', true);

  fetch('/contact', {
    method: 'POST',
    body: new FormData(form),
    credentials: 'same-origin'
  })
    .then(function (res) {
      // If Shopify blocks with a challenge or non-OK status, do a real submit so the challenge can run.
      if (!res.ok) throw new Error('non-ok');

      // If it succeeds, redirect to your confirmation page
      window.location.assign(confirmUrl);
    })
    .catch(function () {
      // FALLBACK: let Shopify handle the challenge in a full-page submit
      try {
        // Remove this listener’s prevention by submitting natively
        form.submit();
      } catch (err2) {
        // If even that fails, show error
        if (err) err.style.display = 'block';
        setBtn('Start the Series', false);
      }
    });
}, true);
